export default __webpack_public_path__ + "static/media/est-sp.885272dc.png";